// 个人信息
export const GET_MY_INFO = 'GET_MY_INFO'
export const GET_PERSONAL_INFO = 'GET_PERSONAL_INFO'
export const SET_PERSONAL_INFO = 'SET_PERSONAL_INFO'
export const SAVE_PERSONAL_INFO = 'SAVE_PERSONAL_INFO'
export const SAVE_PERSONAL_INFO_All = 'SAVE_PERSONAL_INFO_All'
export const GET_PERSONAL_INIT_DATA = 'GET_PERSONAL_INIT_DATA'
export const GET_BYCAT_KEY = 'GET_BYCAT_KEY' //获取区域/城市
export const GET_ALL_SELECT = 'GET_ALL_SELECT' //获取其他Select数据

// 企业信息
export const ENTERPRISE_INFO = 'ENTERPRISE_INFO'
export const GET_ENTERPRISE_INFO = 'GET_ENTERPRISE_INFO'
export const SET_ENTERPRISE_INFO = 'SET_ENTERPRISE_INFO'
export const SAVE_ENTERPRISE_INFO = 'SAVE_ENTERPRISE_INFO'



// WEBPACK FOOTER //
// ./src/vuex/types/personalCenter/myInfo.js